import { render } from "./TipDetailsModal.vue?vue&type=template&id=0405e6b2&scoped=true"
import script from "./TipDetailsModal.vue?vue&type=script&lang=js"
export * from "./TipDetailsModal.vue?vue&type=script&lang=js"

import "./TipDetailsModal.vue?vue&type=style&index=0&id=0405e6b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0405e6b2"]])

export default __exports__